import React from "react";
import styles from './Alert.module.scss';
import PropTypes from "prop-types";

const Alert = ({
  message,
  type,
  isToast = false,
}) => {
  return (
    <div className={`${styles.alert} ${styles[type]} ${isToast ? styles.toast : ''}`}>
      <span className={`${styles.icon} ${styles[type]}`}></span>
      <span className={styles.message}>{message}</span>
    </div>
  );
};

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']).isRequired,
  isToast: PropTypes.bool
};

export default Alert;
